<template>
    <div
        v-if="$mq != 'mobile'"
        class="volet"
        v-bind:id="type"
        v-bind:class="[ deplie ? 'deplie' : 'replie', {home : home}]"
        @click="ouvrir_volet(type)"
        @mousedown="fermerVoletBas"
    >
        <v-chronologie v-if="type == 'chronologie'"></v-chronologie>
        <v-localisations v-if="type == 'localisations'"></v-localisations>
        <v-acteurs v-if="type == 'acteurs'"></v-acteurs>
        <v-interventions v-if="type == 'interventions'"></v-interventions>
        <v-mots-clefs v-if="type == 'mots_clefs'"></v-mots-clefs>
        <v-projet v-if="projet_actif && deplie"></v-projet>   
        <div class="volet-overlay"></div>
    </div>
    <div
        v-else
        @click="ouvrir_volet(type)"
        class="deplie home"
        v-bind:id="type"
    >
        <v-interventions v-if="type == 'interventions'"></v-interventions>
        <v-projet v-if="projet_actif && deplie"></v-projet>   
        <div class="volet-overlay"></div>
    </div>
</template>

<script>
    import Chronologie from './Contenus/Chronologie.vue';
    import Localisations from './Contenus/Localisations.vue';
    import Acteurs from './Contenus/Acteurs.vue';
    import Interventions from './Contenus/Interventions.vue';
    import MotsClefs from './Contenus/MotsClefs.vue';
    import Projet from './Contenus/Projet.vue';
    import { state } from '../main.js';

    export default {
        props: ['type'],
        data() {
            return {
                state: state,
                mode: state.mode,
                home: false,
                deplie: false,
                projet_actif: false
                // vue_principale: state.vue_principale,
                // modal_ajout: state.modal_ajout,
                // modal_objet: state.modal_objet
            }
        },

        components: {
            'v-chronologie': Chronologie,
            'v-mots-clefs': MotsClefs,
            'v-localisations': Localisations,
            'v-acteurs': Acteurs,
            'v-interventions': Interventions,
            'v-projet': Projet
        },

        created: function() {
            if (this.$route.params.vue == undefined) {
                this.home = true;
            } else if (this.$route.params.vue == this.type) {
                this.deplie = true;
            } else {
                this.deplie = false;
            }

            if (this.$route.params.projet != undefined) {
                this.projet_actif = true;
            } else {
                this.projet_actif = false;
            }
        },
        watch: {
            '$route.params.vue'(cible) {
                this.home = false;
                if (cible == this.type) {
                    this.deplie = true;
                } else {
                    this.deplie = false;
                }
            },
            '$route.params.projet'(cible) {
                if (cible != undefined) {
                    this.projet_actif = true;
                } else {
                    this.projet_actif = false;
                }
            }
        },

        methods: {
            ouvrir_volet(route_cible) {
                if (this.deplie == false) {
                    this.$router.push({ name: 'vue', params: { vue:route_cible } });
                    //console.log("HERE : scroll mot clés");
                    if(document.getElementById("mots_clefs")){
                        setTimeout(function(){
                            if(document.getElementById("mots_clefs").classList.contains("replie")){
                                document.getElementById("mots_clefs").getElementsByClassName("overflow")[0].scrollTop = 0;
                                document.getElementById("mots_clefs").scrollTop = 0;
                            }else{}
                        },50);
                    }
                }
            },
            fermerVoletBas(){
                document.body.setAttribute("data-footer",false);
                document.body.setAttribute("data-mode","");
            }
        }
    };
</script>

<style>
    .volet {
      position:relative;
      display:inline-block;
      height:100vh;
      transition: width 0.5s;
      overflow: hidden;
      user-select: none;
    }

    .volet + .volet {
        border-left: 2px solid black;
    }

    .volet.replie {
        width: 39px;
        cursor: pointer;
        overflow: hidden!important;
        scrollbar-width: none!important;
    }
    .volet.deplie {
        width:calc(100vw - (4 * 39px ) - 0px);
    }
    .volet.home {
        width:calc(100% / 5);
    }

    .volet.home:hover {
        width:28vw;
    }

    .volet.replie:not(.home) > div > .titre {
        transform: rotate(-90deg);
        width:250px;
        left:-244px;
        top:var(--tbm);
        text-align: right;
        transform-origin: top right;
        line-height: 26px;
    }

    .volet.replie > * {
        pointer-events: none;
    }
</style>